/*
 * @Author: 吴文洁
 * @Date: 2019-10-30 11:45:25
 * @LastEditors: liguokang
 * @LastEditTime: 2021-06-03 11:01:47
 * @Description:
 */
const institutionModule = {
  state: {
    insts: [],
    currentInst: window.LS.getObj('instInfo') || {},
    homeworkTab: 'tab1',
    commentTeacherTab: 'tab1',
    couponTab: 'tab1',
  },
  mutations: {
    saveUserInsts(state, payload) {
      state.insts = payload.insts;
      window.LS.setItem('weixin_instList', JSON.stringify(payload.insts));
      if (window.LS.getItem('instId')) {
        let inst = null;
        _.filter(payload.insts, item => {
          if (item.instId === window.LS.getItem('instId')) {
            inst = item;
          }
        });
        if (!inst) {
          state.currentInst = payload.insts[0];
        } else {
          state.currentInst = inst;
        }
      } else {
        state.currentInst = payload.insts[0];
      }
      window.LS.setObj('instInfo', state.currentInst);
      window.LS.setItem('instId', state.currentInst.instId);
    },

    changeCurrentInst(state, payload) {
      let inst = null;
      _.filter(state.insts, item => {
        if (item.instId === payload.instId) {
          inst = item;
        }
      });
      if (inst) {
        state.currentInst = inst;
        window.LS.setObj('instInfo', state.currentInst);
        window.LS.setItem('instId', state.currentInst.instId);
      }
    },

    changeHomeworkTab(state, payload) {
      payload.tabkey ? (state.homeworkTab = 'tab2') : (state.homeworkTab = 'tab1');
    },

    changeCommentTeacherTab(state, payload) {
      payload.tabkey ? (state.commentTeacherTab = 'tab2') : (state.commentTeacherTab = 'tab1');
    },

    changeCouponTab(state, payload) {
      state.couponTab = 'tab' + payload.tabkey + 1;
    },
  },
  actions: {
    saveUserInsts({ commit }, payload) {
      commit('saveUserInsts', payload);
    },

    changeCurrentInst({ commit }, payload) {
      commit('changeCurrentInst', payload);
    },

    changeHomeworkTab({ commit }, payload) {
      commit('changeHomeworkTab', payload);
    },

    changeCommentTeacherTab({ commit }, payload) {
      commit('changeCommentTeacherTab', payload);
    },

    changeCouponTab({ commit }, payload) {
      commit('changeCouponTab', payload);
    },
  },
  getters: {
    getUserInstsState: state => {
      return state.insts;
    },
    getUserCurrentInstState: state => {
      return state.currentInst;
    },
  },
};

export default institutionModule;



// WEBPACK FOOTER //
// ./src/store/modules/institution.js